import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { NewsService } from '../../../../../app/shared/API-Service/services/news.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThisReceiver } from '@angular/compiler';
import { BaseComponent } from 'src/app/shared/components/base/base.component';


@Component({
  selector: 'app-view-news',
  templateUrl: './view-news.component.html',
  styleUrls: ['./view-news.component.css']
})
export class ViewNewsComponent extends BaseComponent implements OnInit {
  News:object [] = [];
  img : string = Image;
  NewsName: any;
  closeResult: string;
  imagesView: any;
  insertForm: FormGroup;
  NewsImages: any;
  NewsId: any;
  ShowPhoto: boolean;
  images: File
  CreatNewsPicForm: any = new FormData();
  submit: boolean = true;
  constructor(private _formBuilder: FormBuilder,private _NewsService:NewsService,private _Router:Router,public modalService: NgbModal) { 
    super()
  }

  ngOnInit(): void {
    this.getnews();
    this.initForm();
  }
  get fc() {
    return this.insertForm.controls;
  }
  initForm() {
    this.insertForm = this._formBuilder.group({
      title: [ '',],
      titleAr: [ '', Validators.required],
      order:['',Validators.required]
    });
  }
  open(content,item) {
    this.NewsId=item.id;
    this.NewsName=item.titleAr
    this.GetNewsImages(this.NewsId)
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true,size: 'xl'  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  GetNewsImages(NewsId){
    this._NewsService.GetNewsImage(NewsId).subscribe(res=>{
      this.NewsImages=res.data;
      this.NewsImages.forEach(element => {
        element.image=environment.ServerImages_URL+'/'+element.image
      });
    })
  }

  onFileSelected(event, element) {
    // this.element = element
  //   this.haveImage = true;
    let filesAmount = event.target.files.length;
    let files = event.target.files;
    const  reader = new FileReader();
    // this.imagePath = files;   
    const video = "video";
    if(files[0].type?.includes(video)){
      this.ShowPhoto=false;
    }
    else{
     this.ShowPhoto=true;
    }
    // reader.readAsDataURL(files);
    // reader.onload = () => {
    //   this.images=event.target.files[0];
    //   this.imagesView = reader.result as string;
    // }


    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.images = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imagesView = reader.result as string;
        // this.insertForm.patchValue({
        //   fileSource: reader.result,
        // });
      };
      reader.onloadend = (_event) => {
        event.target.value = null; // Reset the value of the file input element
      };
    }

  }

  deleteimage(imgindex) {
    // this.images.splice(imgindex, 1);
    this.imagesView=null
this.images=null
  }
  deleteNewsImage(id){
    Swal.fire({
      title: 'هل تريد مسح العنصر ؟',
      text: "لن يكون لك صلاحية إعادته مره اخرى",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'الغاء',
      confirmButtonText: 'امسح العنصر !'
    }).then((result) => {
      if (result.isConfirmed) {
        this._NewsService.DeleteNewsImage(id).subscribe((res) => {
          Swal.fire({
            icon: "success",
            title: "تم المسح بنجاح",
            showConfirmButton: false,
            timer: 1500,
          });
       this.GetNewsImages(this.NewsId);
        },(err) => {
          Swal.fire({
            icon: 'error',
            title: 'خطأ',
            text:err.error.message    
          })
        },() => {
        })
      }
    }) 
  
  }
OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  private getDismissReason(reason: any): string {
  
    if (reason === ModalDismissReasons.ESC) {

       this.insertForm.reset();
      this.imagesView="";

      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      this.insertForm.reset();
      this.imagesView="";

      return 'by clicking on a backdrop';
    } else {
      this.insertForm.reset();
      this.imagesView="";

      return `with: ${reason}`;
    }
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getnews();
  }

  getnews(){
    this._NewsService.GetNewsPaged(this.pager).subscribe((res) => {
      this.News = res.data.items
      this.totalCount=res.data.totalCount
    
    },(err)=>{
    },() =>{
    });
  }
  update(id){
  //  this._NewsService.Data.next(data);
    this._Router.navigate(['/content/admin/update-news',id]);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._NewsService.DeleteNews(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
            this.images=null

         this.getnews();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }

    modalclose(){
      this.insertForm.reset();
      this.imagesView="";
      this.images=null
      this.CreatNewsPicForm=new FormData()
      this.modalService.dismissAll();
    }
    Submit(){
      if (this.insertForm.status == "VALID") {
        this.submit = false

        this.CreatNewsPicForm.append('NewsImage', this.images)
        this.CreatNewsPicForm.set('Title',this.insertForm.get('title').value);
        this.CreatNewsPicForm.set('TitleAr',this.insertForm.get('titleAr').value);
        this.CreatNewsPicForm.set('Order',this.insertForm.get('order').value);
        this.CreatNewsPicForm.set('NewsId',this.NewsId)
        this._NewsService.CreateNewsImage(this.CreatNewsPicForm).subscribe(
          (response) => {
          Swal.fire({
          icon: "success",
          title: "تم الحفظ بنجاح",
          showConfirmButton: false,
          timer: 1500,
          });
          this.GetNewsImages(this.NewsId);
          this.insertForm.reset();
          this.imagesView=null;
          this.images=null;
          this.CreatNewsPicForm= new FormData();
          this.submit = true
  
       //   this._Router.navigateByUrl("content/admin/ViewProjects");
    
        },
          (err) => {
            Swal.fire({
              icon: "error",
              title:err.error.message
              });
                
           this.submit = true
  
              }   );
      }
       else {
        this.submit = true

        this.insertForm.markAllAsTouched();
      }
      // this.images.forEach(element => {
      // });
      
    }
}
